<template>
  <dashboard-management
    :application-id="applicationId"
    :change-post-status="api.changePostStatus"
    :get-all-posts="api.getAllPosts"
    :get-applications="api.getApplications"
    :get-document="api.getDocument"
    :get-guides="api.getGuides"
    :get-links="api.getCards"
    :get-modules="api.getModules"
    :get-types="api.getTypes"
    :get-videos="api.getVideos"
    :mark-messages="api.markMessages"
    :update-participant-workshop-status="api.updateParticipantWorkshopStatus"
  />
</template>
<script>
import DashboardManagement from '@quisit/dashboard-management';
import {
  getTypes,
  getAllPosts,
  changePostStatus,
  updateParticipantWorkshopStatus,
  getVideos,
  getGuides,
  getApplications,
  getModules,
  getCards,
  getDocument,
} from '@/services/mipe/dashboard-management';
import dashbordApi from '@/services/mipe/dashboard';
import applications from '@/utils/constants/applications';

export default {
  name: 'DashboardMaintenance',
  components: { DashboardManagement },
  computed: {
    api() {
      return Object.freeze({
        getTypes,
        getAllPosts,
        getApplications,
        getModules,
        getCards,
        changePostStatus,
        updateParticipantWorkshopStatus,
        markMessages: dashbordApi.markMessages,
        getGuides: getGuides,
        getVideos: getVideos,
        getDocument: getDocument,
      });
    },
    applicationId() {
      return applications.RemPro;
    },
  },
};
</script>
<style scoped>
::v-deep(.bg-gray) {
  background-color: unset !important;
}
</style>
